import React from 'react';
import {CartItemDataHook} from '../../CartItem';
import s from '../../CartItem.scss';
import {LineItemModel} from '../../../../../../domain/models/LineItem.model';

export const TotalPrice = ({
  lineItem,
  shouldShowCrossedOutPriceOnLineItemLevel,
}: {
  lineItem: LineItemModel;
  shouldShowCrossedOutPriceOnLineItemLevel: boolean;
}) => {
  return (
    <div
      className={s.totalPrice}
      data-hook={CartItemDataHook.TotalPrice}
      data-wix-item-total-price={CartItemDataHook.TotalPrice}>
      {shouldShowCrossedOutPriceOnLineItemLevel && lineItem.crossedOutPrice?.formattedConvertedAmount && (
        <div data-hook={CartItemDataHook.ComparePriceOnLineItem} className={s.comparePrice}>
          {lineItem.crossedOutPriceByQuantity.formattedConvertedAmount}
        </div>
      )}
      <div className={s.totalPriceText}>{lineItem.lineItemPrice.formattedConvertedAmount}</div>
    </div>
  );
};
